import { render, staticRenderFns } from "./AddInsurance.vue?vue&type=template&id=9507e0b2&scoped=true"
import script from "./AddInsurance.vue?vue&type=script&lang=js"
export * from "./AddInsurance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9507e0b2",
  null
  
)

export default component.exports